<div class="transfer-manager min-h-screen">
  <router-outlet></router-outlet>
</div>